import moment from 'moment';

import { luftGet } from '../shared/http';
import { loggedUserRequestErrorHandler } from '../shared/http/error';

// actions

const GET_SHIPPING_COMPANIES = 'luft/shipping-company/GET_SHIPPING_COMPANIES';
const GET_SHIPPING_COMPANIES_SUCCESS =
  'luft/shipping-company/GET_SHIPPING_COMPANIES_SUCCESS';
const GET_SHIPPING_COMPANIES_FAILURE =
  'luft/shipping-company/GET_SHIPPING_COMPANIES_FAILURE';

// reducer

const initialState = {
  isFetching: false,
  error: '',
  requested: '',
  list: [],
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_SHIPPING_COMPANIES:
      return {
        ...state,
        isFetching: true,
        error: '',
        requested: moment().format('YYYY-MM-DD HH:mm:ss'),
      };

    case GET_SHIPPING_COMPANIES_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: '',
        list: action.list,
      };

    case GET_SHIPPING_COMPANIES_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.error,
      };

    default:
      return state;
  }
}

export default reducer;

// actions creators

function _getShippingCompanies() {
  return { type: GET_SHIPPING_COMPANIES };
}

function _getShippingCompaniesSuccess(list) {
  return {
    type: GET_SHIPPING_COMPANIES_SUCCESS,
    list,
  };
}

function _getShippingCompaniesFailure(error) {
  return {
    type: GET_SHIPPING_COMPANIES_FAILURE,
    error,
  };
}

// thunk action creators

export function getShippingCompanies() {
  return function (dispatch) {
    (async () => {
      dispatch(_getShippingCompanies());

      try {
        const response = await luftGet('/Customer/GetShippingCompanies');
        dispatch(_getShippingCompaniesSuccess(response.data));
      } catch (error) {
        console.log(error);
        loggedUserRequestErrorHandler(
          dispatch,
          error,
          _getShippingCompaniesFailure(error.message),
        );
      }
    })();
  };
}
